import React, { useState , useEffect } from 'react';
import '../Component/header.css'
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import CloseIcon from '@mui/icons-material/Close';
import '../App.css'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

function Header() {
    const [isActive, setIsActive] = useState(false);
    const toggleNavbar = () => {
      setIsActive(!isActive);
    };
    const [theme , setTheme] = useState("Dark-theme");
    const toggleTheme = () => {
      if(theme == "Dark-theme"){
        setTheme("Light-theme")
      }else{
        setTheme("Dark-theme")
      }
    }
    useEffect(() => {
      document.body.className = theme;
    }, [theme]);
  
    return (
      <header className={`header ${isActive ? 'active' : ''}`}>
        <label className="logo"><span className='tag'>{`< / > `}</span>Waleed's Portfolio</label> 
        <div className='main-nav'>
        <nav className="navbar">
          <ul className="navbar-list">
            <li>
              <a className="navbar-link" href="#">
                Home
              </a>
            </li>
            <li>
              <a className="navbar-link" href="#about">
                About
              </a>
            </li>
            <li>
              <a className="navbar-link" href="#skills">
                Skills
              </a>
            </li>
            <li>
              <a className="navbar-link" href="#experience">
                Experience
              </a>
            </li>
            <li>
              <a className="navbar-link" href="#projects">
                Projects
              </a>
            </li>
            <li>
              <a className="navbar-link" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </nav>
        <div className="dlmode" >
        {theme == "Light-theme" ? <DarkModeOutlinedIcon onClick={() => toggleTheme()} /> : <LightModeOutlinedIcon onClick={() => toggleTheme()}/>}
        </div>
      </div>
        <div className="mobile-navbar-btn" >
          <button
          onClick={toggleNavbar}
            className="mobile-nav-icon"
          >{isActive ? <CloseIcon /> : <AlignHorizontalRightIcon />}</button>
        </div>
      </header>
    );
  }
  
  export default Header;
  